var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.styles.root},[_c('TheText',{class:_vm.styles.title,attrs:{"name":"titleXL"}},[_vm._v("Выберите банк или эл. кошелёк для оплаты")]),_vm._l((_vm.banks),function(bank,index){return _c('BankCell',_vm._b({key:bank.id,class:_vm.styles.cell},'BankCell',bank,false))})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }